import type { TextTemplatePlaceholder } from "@exonn/js-sdk";
import { Flex } from "src/components/Flex.tsx";
import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { ChipV2, type ChipV2Size } from "src/components/ChipV2/ChipV2.tsx";
import React from "react";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";

await loadTranslations(TranslationNamespaceEnum.InputPlaceholdersComponent);

export const Placeholders = ({
  placeholders = [],
  disabled,
  onSelectPlaceholder,
  chipSize = "small",
}: {
  placeholders?: TextTemplatePlaceholder[];
  disabled?: boolean;
  onSelectPlaceholder?: (placeholder: TextTemplatePlaceholder) => void;
  chipSize?: ChipV2Size;
}) => {
  const { t } = useTranslation(
    TranslationNamespaceEnum.InputPlaceholdersComponent,
  );
  if (placeholders.length === 0) {
    return null;
  }

  return (
    <Flex gap={"5px"} flexWrap={"wrap"}>
      {placeholders.map((placeholder, index) => {
        const getTooltipContent = () => {
          if (placeholder.description) {
            return placeholder.description;
          }
          if (placeholder.example_values.length) {
            return t("examples") + ": " + placeholder.example_values.join(", ");
          }
          return placeholder.description;
        };
        const tooltipContent = getTooltipContent();
        return (
          <TooltipV2
            key={index}
            disabled={!tooltipContent}
            content={tooltipContent}
          >
            <ChipV2
              skin={"grey"}
              size={chipSize}
              disabled={disabled}
              onClick={() => {
                if (!disabled) {
                  onSelectPlaceholder?.(placeholder);
                }
              }}
              label={placeholder.label}
            />
          </TooltipV2>
        );
      })}
    </Flex>
  );
};
